import { render, staticRenderFns } from "./OrganizationType.vue?vue&type=template&id=4feb0b9a"
import script from "./OrganizationType.vue?vue&type=script&lang=js"
export * from "./OrganizationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports